export const entitiesString = process.env.REACT_APP_ENTITIES;
export const defaultEntityName = process.env.REACT_APP_ENTITIES_DEFAULIT_ENTITY_NAME || '';
export const defaultEntityId = process.env.REACT_APP_ENTITIES_DEFAULIT_ENTITY_ID || '';
export const entitiesQueryParamName = process.env.REACT_APP_ENTITIES_QUERY_PARAM_NAME || 'entityId';

